import register from "preact-custom-element";
import { MbbDataSelector } from "./mbb-data-selector";

register(MbbDataSelector, "ice-mbb-data-selector", ["heading", "packages"], {
  shadow: false,
});
